import { render, staticRenderFns } from "./CourseErrorHeader.vue?vue&type=template&id=de1c8786"
import script from "./CourseErrorHeader.vue?vue&type=script&lang=ts"
export * from "./CourseErrorHeader.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports